import { types } from 'mobx-state-tree';

const AssignmentQuestion = types.model({
  questionText: types.string,
  id: types.string,
});

export default AssignmentQuestion;
